module.exports = __webpack_public_path__ + "c39ea8d91d6174e54204322a210885f6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-26.png
// module id = 1675
// module chunks = 0